var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 108,
    height: 121,
    viewBox: "0 0 108 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.1292 5.92563L73.8163 20.7751L45.0685 0.5L24.1227 29.0622L0.451234 21.4783L13.8802 62.5668L13.8802 63.7109C6.23197 64.0362 -3.03641e-07 70.3752 0 78.1475C-1.99335e-07 86.1278 6.43232 92.5971 14.367 92.5971L15.4056 92.5965C20.2017 108.727 35.6907 120.5 54 120.5C72.3093 120.5 87.7983 108.727 92.5944 92.5964L94.1073 92.5894C101.822 92.3378 108 85.9682 108 78.1475L107.992 77.6705C107.747 70.0766 101.677 63.9638 94.1292 63.7062V5.92563ZM20.8697 63.1903L20.8073 82.0164C20.8073 99.1716 35.2822 113.191 53.3531 113.518L54 113.524C72.155 113.524 86.8434 99.7067 87.1865 82.6277L87.191 52.028L20.8697 63.1903ZM101.064 78.1475C101.064 82.1078 98.0016 85.3487 94.1284 85.6051V70.6898L94.8916 70.7802C98.3963 71.3815 101.064 74.4511 101.064 78.1475ZM13.487 70.7253L13.8716 70.6898V85.6051C9.99841 85.3487 6.93578 82.1078 6.93578 78.1475C6.93578 74.3191 9.79764 71.1631 13.487 70.7253Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5072 71.637C71.0355 71.637 71.5427 71.5467 72.014 71.3809V74C72.014 82.8493 59.9594 82.8493 59.9594 74V69.2739C59.9594 63.6267 64.8685 61.5833 68.4212 63.1437C66.9745 63.8941 65.9867 65.4007 65.9867 67.137C65.9867 69.6223 68.0106 71.637 70.5072 71.637Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M49.914 71.3809C49.4427 71.5467 48.9355 71.637 48.4072 71.637C45.9106 71.637 43.8867 69.6223 43.8867 67.137C43.8867 65.4007 44.8745 63.8941 46.3212 63.1437C42.7685 61.5833 37.8594 63.6267 37.8594 69.2739V74C37.8594 82.8493 49.914 82.8493 49.914 74V71.3809Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.2004 101.5C59.2004 98.1863 61.8989 95.5 65.2277 95.5C68.5564 95.5 71.255 98.1863 71.255 101.5C71.255 104.814 68.5564 107.5 65.2277 107.5C61.8989 107.5 59.2004 104.814 59.2004 101.5Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo03);
export default __webpack_public_path__ + "static/media/logo03.a7c38d140728704df82f4a0d46c15874.svg";
export { ForwardRef as ReactComponent };